import { render, staticRenderFns } from "./ExtinguisherReport.vue?vue&type=template&id=4b4498f2&"
import script from "./ExtinguisherReport.vue?vue&type=script&lang=js&"
export * from "./ExtinguisherReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports